
  import React from "react"
  import Component from "/var/www/html/src/layouts/es.js"
  import data from "/var/www/html/.cache/json/layout-es.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/es.js